import React from 'react'
import { ArrowPathIcon, ChartBarIcon, TableCellsIcon, CalendarDateRangeIcon, ArrowDownOnSquareIcon } from '@heroicons/react/24/outline'

const tableIcon = <TableCellsIcon data-testid='tabular-icon' name='Tabular' className='h-5 w-5 mx-auto' />
const chartIcon = <ChartBarIcon data-testid='graphic-icon' name='Graphic' className='h-5 w-5 mx-auto' />
const refreshIcon = <ArrowPathIcon title='Refresh' data-testid='refresh-icon' name='Refresh' className='h-5 w-5 mx-auto' />
const calendarIcon = <CalendarDateRangeIcon title='Calendar' data-testid='calendar-icon' name='Calendar' className='h-5 w-5' />
const exportIcon = <ArrowDownOnSquareIcon title='Dowload' data-testid='download-icon' name='Download' className='h-5 md:w-16 mx-auto' />

export {
  tableIcon,
  chartIcon,
  refreshIcon,
  calendarIcon,
  exportIcon
}
